import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import Card from "../../../general/Card";
import LeafletMap from "./maps/LeafletMap";
import styles from "./ProdutionPageL2.module.css";
import { ProdutionStore } from "./ProdutionStore";

function ProdutionPageL2({ distrito, menuFilterParams, searchControl }) {
  const [areaMedia, setAreaMedia] = useState(null);
  const [producaoKg, setProducaoEmKg] = useState(null);
  const [producaoMedia, setProducaoMedia] = useState(null);
  const [informacoesPropriedades, setInformacoesPropriedades] = useState(null);

  const setMapImage2 = ProdutionStore((state) => state.setMapImage2);

  const areaMin = ProdutionStore((state) => state.areaMin);
  const areaMax = ProdutionStore((state) => state.areaMax);
  const prodMin = ProdutionStore((state) => state.prodMin);
  const prodMax = ProdutionStore((state) => state.prodMax);

  const { selectedOption, searchInput } = searchControl;
  const { category, subcategoria, natureza } = menuFilterParams;

  const inscricao = Functions.getInscricaoParam(selectedOption, searchInput);
  const proprietario = Functions.getProprietarioParam(
    selectedOption,
    searchInput
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [areaMedia, producaoKg, producaoMedia, informacoesPropriedades] =
          await Promise.all([
            Api.getAreaMedia(
              distrito,
              category,
              subcategoria,
              natureza,
              inscricao,
              proprietario,
              areaMin,
              areaMax,
              prodMin,
              prodMax
            ),
            Api.getProducaoEmKg(
              distrito,
              category,
              subcategoria,
              natureza,
              inscricao,
              proprietario,
              areaMin,
              areaMax,
              prodMin,
              prodMax
            ),
            Api.getProducaoMedia(
              distrito,
              category,
              subcategoria,
              natureza,
              inscricao,
              proprietario,
              areaMin,
              areaMax,
              prodMin,
              prodMax
            ),
            Api.getLocalizacaoPropriedades(
              distrito,
              category,
              subcategoria,
              natureza,
              inscricao,
              proprietario,
              areaMin,
              areaMax,
              prodMin,
              prodMax
            ),
          ]);
        setAreaMedia(areaMedia);
        setProducaoEmKg(producaoKg);
        setProducaoMedia(producaoMedia);
        setInformacoesPropriedades(informacoesPropriedades);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };

    fetchData();
  }, [
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    areaMin,
    areaMax,
    prodMin,
    prodMax,
  ]);

  return (
    <div className={styles.produtionPageL2}>
      <div className={styles.produtionPageCards}>
        <div className={styles.cards}>
          <Card
            name="ÁREA MÉDIA (ha)"
            value={areaMedia?.value?.toFixed(2) ?? "..."}
          />
        </div>
        <div className={styles.cards}>
          <Card
            name={`PRODUÇÃO (${producaoKg?.unidade || "..."})`}
            value={producaoKg?.value?.toFixed(0) || "..."}
          />
        </div>
        <div className={styles.cards}>
          <Card
            name={`PRODUÇÃO MÉDIA (${producaoMedia?.unidade || "..."})`}
            value={producaoMedia?.value?.toFixed(2) || "..."}
          />
        </div>
      </div>

      <LeafletMap
        informacoesPropriedades={informacoesPropriedades}
        onImageReady={setMapImage2}
      />
    </div>
  );
}

export default ProdutionPageL2;
